<template>
  <div class="modal fade show" style="display: block; z-index: 10060">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body">
          <button
            class="close-button"
            aria-label="Close"
            disabled
            style="opacity: 0.3; cursor: not-allowed"
          >
            <Icon icon="mdi:close" width="18" height="18" />
          </button>
          <div class="row">
            <div
              class="col-2"
              style="padding: 0px; display: flex; align-items: center; justify-content: center"
            >
              <Icon icon="mdi:phone-log" width="48" height="48" style="color: #3e3efe" />
            </div>
            <div class="col-10">
              <h6 class="title">Save call disposition</h6>
              <small class="sub-title">
                You have an unlogged call. Select a call disposition and click "Log Call & Save
                Disposition" in the footer to log your call.
              </small>
            </div>
          </div>
          <div v-if="!localSelectedDisposition" class="row" style="margin-top: 20px">
            <div class="col-12">
              <div class="alert-message">
                <Icon
                  icon="mdi:alert-circle-outline"
                  width="20"
                  height="20"
                  style="color: #dc3545; margin-right: 8px"
                />
                <span>Please select a call disposition before logging the call.</span>
              </div>
            </div>
          </div>
        </div>
        <div class="footer">
          <div class="row">
            <div class="col-12">
              <button
                type="button"
                class="btn btn-primary w-100"
                @click="$emit('cancel')"
                :disabled="isLoading"
              >
                Go Back to Log Call
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Icon } from "@iconify/vue";

export default {
  name: "DispositionReminderModal",
  components: {
    Icon,
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    callDispositions: {
      type: Array,
      default: () => [],
    },
    selectedCallDisposition: {
      type: Object,
      default: null,
    },
  },
  emits: ["cancel"],
  data() {
    return {
      localSelectedDisposition: this.selectedCallDisposition,
    };
  },
  watch: {
    selectedCallDisposition(newVal) {
      this.localSelectedDisposition = newVal;
    },
  },
  methods: {},
};
</script>

<style scoped>
.modal-content {
  border-radius: 16px !important;
  border: 1px solid #e4e4e7;
  background-color: #fdfdfe !important;
  max-width: 480px;
}

.modal-dialog {
  max-width: 440px;
  z-index: 10020 !important;
}

.modal {
  background-color: rgba(0, 0, 0, 0.1);
  z-index: 10019 !important;
}

.modal-body {
  padding: 28px 24px 18px 24px;
}

.modal-body .title {
  font-weight: 700;
  font-size: 1.1rem;
  margin-bottom: 6px;
  color: #2c2c2e;
}

.modal-body .sub-title {
  font-weight: 400;
  font-size: 0.85rem;
  color: #646464;
  line-height: 1.4;
}

.close-button {
  position: absolute;
  top: 12px;
  right: 15px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #646464;
  transition: color 0.2s;
}

.close-button:hover:not(:disabled) {
  color: #2c2c2e;
}

.footer {
  border-top: 1px solid #e4e4e7;
  padding: 18px 18px 16px 18px;
  width: 100%;
  margin-top: 8px;
}

.footer .row {
  margin: 0;
}

.footer .btn {
  width: 100%;
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 0.8rem;
  font-weight: 500;
  border: 1px solid;
  transition: all 0.2s;
  white-space: nowrap;
  min-width: 0;
}

.footer .btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.footer .btn-cancel {
  color: #646464;
  background-color: #ffffff;
  border-color: #e4e4e7;
}

.footer .btn-cancel:hover:not(:disabled) {
  background-color: #f5f5f5;
  border-color: #d0d5dd;
}

.footer .btn-secondary {
  color: #2d60ff;
  background-color: #ffffff;
  border-color: #2d60ff;
}

.footer .btn-secondary:hover:not(:disabled) {
  background-color: #ececff;
  border-color: #1d4ed8;
}

.footer .btn-primary {
  color: #ffffff;
  background-color: #3e3efe;
  border-color: #3e3efe;
}

.footer .btn-primary:hover:not(:disabled) {
  background-color: #2d2dff;
  border-color: #2d2dff;
}

.loading-text {
  margin-left: 8px;
}

.alert-message {
  display: flex;
  align-items: center;
  padding: 12px;
  background-color: #fff5f5;
  border: 1px solid #fecaca;
  border-radius: 8px;
  color: #dc3545;
  font-size: 0.875rem;
}
</style>
